var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[(_vm.label)?_c('label',{style:(_vm.styleLabel),attrs:{"for":""},domProps:{"innerHTML":_vm._s(_vm.label)}}):_vm._e(),_c('div',{staticClass:"vs-con-input"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.value)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }